export default "__VITE_ASSET__BFKZ_Efr__"